import React, { useState, useContext } from 'react'

import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import FormField from 'components/FormField'
import SoftButton from 'components/SoftButton'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { IntakeContext } from 'context/IntakeContext'
import Slide from '@mui/material/Slide'
import { toast } from 'react-toastify'
import SoftInput from 'components/SoftInput'
import { useApi } from 'hooks/useApi'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const ContactUsModalForm = ({
  handleClose,
  open,
  handleSubmit,
  emailDialogParts,
}) => {
  const { reloadUser, intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)
  const [emailSubject, setEmailSubject] = useState()
  const [emailBody, setEmailBody] = useState()

  const onSubmit = async () => {
    toast.info(
      'Your message has been sent successfully! A member of the PARCO team will respond shortly.',
      {
        position: 'top-center',
        autoClose: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      }
    )
    sendAnEmail()
    handleSubmit()
  }

  const { apiRequest } = useApi()

  const sendAnEmail = async () => {
    const stuff = await apiRequest('/send_mail', {
      method: 'POST',
      body: JSON.stringify({
        toAddress: 'info@goparco.com',
        subject: emailSubject,
        body: emailBody,
        ReplyToAddresses: [intakeState.email],
      }),
    })
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {emailDialogParts[0] || 'Contact The PARCO Team Via Email'}
      </DialogTitle>
      <DialogContent>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
                mb={1}
              >
                <SoftInput
                  placeholder={emailDialogParts[1]}
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                />
              </SoftBox>
              <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
              >
                <SoftInput
                  placeholder={emailDialogParts[2]}
                  multiline
                  rows={5}
                  value={emailBody}
                  onChange={(e) => setEmailBody(e.target.value)}
                />
              </SoftBox>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <SoftButton variant="text" color="dark" onClick={handleClose}>
          Cancel
        </SoftButton>
        <SoftButton
          variant="gradient"
          color="dark"
          sx={{ height: '100%' }}
          onClick={onSubmit}
        >
          Send Message
        </SoftButton>
      </DialogActions>
    </Dialog>
  )
}
